// export const API_URL = "http://fqe-analytics-v2-staging.eu-north-1.elasticbeanstalk.com/";
export const API_URL = "https://api.fqeanalytics.xyz";
//export const API_URL = "http://127.0.0.1:5000";